import { Typography } from "@mui/material"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { IActionButton, PAGE_HEADER_HEIGHT_IN_REM } from "ui/model"
import { isDesktopScreen } from "ui/tools/responsive"
import { FlexBox } from "../FlexBox"
import { PageHeaderDesktopButton } from "./PageHeaderDesktopButton"
import { PageHeaderMobileMenuButton } from "./PageHeaderMobileMenuButton"

interface IPageHeaderProps {
  title: string
  actionButtons?: IActionButton[] | (() => IActionButton[])
}

interface IPageHeaderConnectProps {
  contentWidth: number
}

const PageHeaderFn = React.memo(
  ({ title, actionButtons, contentWidth }: IPageHeaderProps & IPageHeaderConnectProps) => {
    const [refreshIndex, setRefreshIndex] = React.useState(0)
    const displayAsMenu = contentWidth < 550
    if (typeof actionButtons === "function") {
      actionButtons = actionButtons()
    }
    return (
      <FlexBox
        jc="space-between"
        fullWidth
        sx={{
          height: PAGE_HEADER_HEIGHT_IN_REM,
          minHeight: PAGE_HEADER_HEIGHT_IN_REM,
          maxHeight: PAGE_HEADER_HEIGHT_IN_REM,
          padding: "0",
          pl: "1rem",
          pr: "1rem",
          borderBottom: theme => theme.palette.border
        }}>
        <Typography
          id="page-header-title"
          color="textPrimary"
          textTransform="uppercase"
          fontSize="1.1rem"
          lineHeight="1.1rem"
          fontWeight="500"
          ml={isDesktopScreen() ? "2rem" : undefined}>
          {title}
        </Typography>
        {displayAsMenu ? (
          <PageHeaderMobileMenuButton actionButtons={actionButtons || []} />
        ) : (
          <FlexBox
            sx={{
              "& .MuiButton-root": {
                color: theme => theme.palette.text.primary2,
                textTransform: "uppercase",
                fontSize: ".8rem",
                fontWeight: 500,
                p: "1rem !important"
              }
            }}>
            {actionButtons &&
              actionButtons.map((a, index) => (
                <PageHeaderDesktopButton
                  key={index}
                  actionButton={a}
                  index={index}
                  refresh={() => setRefreshIndex(refreshIndex + 1)}
                />
              ))}
          </FlexBox>
        )}
      </FlexBox>
    )
  }
)

export const PageHeader = connect(
  (state: IRootState): IPageHeaderConnectProps => ({
    contentWidth: state.ui.contentWidth
  })
)(PageHeaderFn)
